import { EventsContextProvider } from '@BUP/contexts/EventsContext'
import { CurrentSociogramContextProvider } from '@BUP/contexts/CurrentSociogramContext'

const SociogramProviders = ({ termId, children }) => (
  <EventsContextProvider termId={termId}>
    <CurrentSociogramContextProvider>
      {children}
    </CurrentSociogramContextProvider>
  </EventsContextProvider>
)

export default SociogramProviders
